var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.5,
    height: 24,
    viewBox: "0 0 16.5 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "basic_trashcan",
    transform: "translate(-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    d: "M11.125,24h14.25V3.75H26.5V3H21.25V0h-6V3H10v.75h1.125ZM16,.75h4.5V3H16Zm8.625,3v19.5H11.875V3.75Z",
    transform: "translate(0)",
    fill: "#d00026"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_486",
    "data-name": "Rectangle 486",
    width: 0.75,
    height: 12.75,
    transform: "translate(15.625 7.5)",
    fill: "#d00026"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_487",
    "data-name": "Rectangle 487",
    width: 0.75,
    height: 12.75,
    transform: "translate(20.125 7.5)",
    fill: "#d00026"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.95c4cd7ed216a6430baf69ccae4e60d9.svg";
export { ForwardRef as ReactComponent };